import { render, staticRenderFns } from "./SpecialPricingBase.vue?vue&type=template&id=0b7667a9&"
import script from "./SpecialPricingBase.vue?vue&type=script&lang=js&"
export * from "./SpecialPricingBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports